import styled from 'styled-components'

import { media } from '@/theme/common'

// Note: 30rem (not the filter bar's usual 16rem) because the amenity/space tree has deeper
// indentation, checkboxes, and longer space names than a typical filter select, so the trigger
// (and, following it, the dropdown - which auto-matches the trigger's width) needs to be fixed
// wider than the filter bar would otherwise size it to.
//
// Sets that width via CSS instead of Select's own `width` prop (which applies as an inline
// style) - an inline style can't be overridden by NavigationLeftFilters' mobile
// `width: 100%` rule at any specificity short of `!important`, since inline styles outrank
// every plain CSS selector regardless of specificity. && (doubling this styled-component's own
// generated class) beats NavigationLeftFilters' `> *:not(...)` descendant selector on
// specificity alone (precedented by BulkActionTooltip in ui/table's table.styled.ts), so the
// mobile override there can stay a plain `width: 100%` instead of needing `!important` too.
export const AmenitySpaceSelectWrapper = styled.div`
  && {
    flex-shrink: 0;
    width: 30rem;
    max-width: 100%;

    ${media.down('sm')} {
      width: 100%;
    }
  }
`
